{
  "version": 1,
  "source": {
    "image": "docs/reference/cornelis-anthonisz-1538.jpg",
    "width": 2000,
    "height": 1454
  },
  "method": {
    "blurSigmaPx": 3,
    "stepPx": 2,
    "minPixels": 500,
    "candidates": ["nearFields", "polderFields", "gardenGrass"]
  },
  "regions": {
    "polder-0-0-1": {
      "class": "polderFields",
      "pixels": 881,
      "votes": {
        "nearFields": 4,
        "polderFields": 835,
        "gardenGrass": 42
      }
    },
    "polder-0-1-1": {
      "class": "polderFields",
      "pixels": 443,
      "votes": {
        "nearFields": 31,
        "polderFields": 408,
        "gardenGrass": 4
      },
      "borrowedFrom": "polder-1-1-1"
    },
    "polder-0-2-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-1-2-1"
    },
    "polder-0-3-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-1-2-1"
    },
    "polder-0-4-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-2-3-1"
    },
    "polder-0-7-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-2"
    },
    "polder-1-0-1": {
      "class": "polderFields",
      "pixels": 1464,
      "votes": {
        "nearFields": 65,
        "polderFields": 1390,
        "gardenGrass": 9
      }
    },
    "polder-1-1-1": {
      "class": "polderFields",
      "pixels": 2047,
      "votes": {
        "nearFields": 174,
        "polderFields": 1838,
        "gardenGrass": 35
      }
    },
    "polder-1-2-1": {
      "class": "polderFields",
      "pixels": 1145,
      "votes": {
        "nearFields": 153,
        "polderFields": 959,
        "gardenGrass": 33
      }
    },
    "polder-1-3-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-2-2-1"
    },
    "polder-1-4-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-2-3-1"
    },
    "polder-1-7-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-2"
    },
    "polder-1-7-2": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-2"
    },
    "polder-2-0-1": {
      "class": "polderFields",
      "pixels": 1410,
      "votes": {
        "nearFields": 63,
        "polderFields": 1338,
        "gardenGrass": 9
      }
    },
    "polder-2-1-1": {
      "class": "polderFields",
      "pixels": 2502,
      "votes": {
        "nearFields": 129,
        "polderFields": 2367,
        "gardenGrass": 6
      }
    },
    "polder-2-2-1": {
      "class": "polderFields",
      "pixels": 3934,
      "votes": {
        "nearFields": 21,
        "polderFields": 3856,
        "gardenGrass": 57
      }
    },
    "polder-2-3-1": {
      "class": "polderFields",
      "pixels": 1352,
      "votes": {
        "nearFields": 14,
        "polderFields": 1319,
        "gardenGrass": 19
      }
    },
    "polder-2-3-2": {
      "class": "polderFields",
      "pixels": 676,
      "votes": {
        "nearFields": 1,
        "polderFields": 633,
        "gardenGrass": 42
      }
    },
    "polder-2-4-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-3-1"
    },
    "polder-2-5-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-2"
    },
    "polder-2-6-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-5"
    },
    "polder-2-7-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-3-0-1": {
      "class": "polderFields",
      "pixels": 2,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 2
      },
      "borrowedFrom": "polder-2-0-1"
    },
    "polder-3-1-1": {
      "class": "polderFields",
      "pixels": 567,
      "votes": {
        "nearFields": 81,
        "polderFields": 471,
        "gardenGrass": 15
      }
    },
    "polder-3-2-1": {
      "class": "polderFields",
      "pixels": 2826,
      "votes": {
        "nearFields": 82,
        "polderFields": 2729,
        "gardenGrass": 15
      }
    },
    "polder-3-3-1": {
      "class": "polderFields",
      "pixels": 27854,
      "votes": {
        "nearFields": 5363,
        "polderFields": 22097,
        "gardenGrass": 394
      }
    },
    "polder-3-3-2": {
      "class": "polderFields",
      "pixels": 33,
      "votes": {
        "nearFields": 0,
        "polderFields": 31,
        "gardenGrass": 2
      },
      "borrowedFrom": "polder-3-3-1"
    },
    "polder-3-4-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-3-1"
    },
    "polder-3-4-2": {
      "class": "polderFields",
      "pixels": 2734,
      "votes": {
        "nearFields": 365,
        "polderFields": 2336,
        "gardenGrass": 33
      }
    },
    "polder-3-4-3": {
      "class": "nearFields",
      "pixels": 331,
      "votes": {
        "nearFields": 174,
        "polderFields": 54,
        "gardenGrass": 103
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-3-4-4": {
      "class": "nearFields",
      "pixels": 39818,
      "votes": {
        "nearFields": 27667,
        "polderFields": 8808,
        "gardenGrass": 3343
      }
    },
    "polder-3-4-5": {
      "class": "polderFields",
      "pixels": 12836,
      "votes": {
        "nearFields": 4956,
        "polderFields": 7800,
        "gardenGrass": 80
      }
    },
    "polder-3-4-6": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-5"
    },
    "polder-3-5-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-3-6-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-3-7-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-4-0-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-1-1"
    },
    "polder-4-0-2": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-1-1"
    },
    "polder-4-1-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-2-1"
    },
    "polder-4-1-2": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-2-1"
    },
    "polder-4-2-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-3-1"
    },
    "polder-4-2-2": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-2"
    },
    "polder-4-3-1": {
      "class": "polderFields",
      "pixels": 13143,
      "votes": {
        "nearFields": 103,
        "polderFields": 11826,
        "gardenGrass": 1214
      }
    },
    "polder-4-3-2": {
      "class": "polderFields",
      "pixels": 11682,
      "votes": {
        "nearFields": 2791,
        "polderFields": 7846,
        "gardenGrass": 1045
      }
    },
    "polder-4-3-3": {
      "class": "polderFields",
      "pixels": 3873,
      "votes": {
        "nearFields": 6,
        "polderFields": 2101,
        "gardenGrass": 1766
      }
    },
    "polder-4-4-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-4-5-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-4-6-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-4-7-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-5-0-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-1-1"
    },
    "polder-5-1-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-2-1"
    },
    "polder-5-2-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-3-1"
    },
    "polder-5-2-2": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-5-3-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-5-4-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-5-4-2": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-5-5-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-5-6-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-5-7-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-6-0-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-2-1"
    },
    "polder-6-1-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-6-2-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-6-3-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-6-4-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-6-5-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-6-6-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-6-7-1": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    },
    "polder-7-0-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-2-1"
    },
    "polder-7-1-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-7-2-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-7-4-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-7-5-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-7-6-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "polder-7-7-1": {
      "class": "polderFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-4-3-1"
    },
    "garden-nieuwe-nonnen-paterserf": {
      "class": "gardenGrass",
      "pixels": 59,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 59
      }
    },
    "garden-south": {
      "class": "polderFields",
      "pixels": 1696,
      "votes": {
        "nearFields": 0,
        "polderFields": 1650,
        "gardenGrass": 46
      }
    },
    "garden-lastage-meadow": {
      "class": "gardenGrass",
      "pixels": 379,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 379
      }
    },
    "garden-lastage-timber-yard": {
      "class": "gardenGrass",
      "pixels": 27,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 27
      }
    },
    "garden-reguliershof": {
      "class": "gardenGrass",
      "pixels": 146,
      "votes": {
        "nearFields": 1,
        "polderFields": 48,
        "gardenGrass": 97
      }
    },
    "garden-kartuizers": {
      "class": "gardenGrass",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      }
    },
    "garden-begijnhof": {
      "class": "gardenGrass",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      }
    },
    "garden-paulusbroeders": {
      "class": "gardenGrass",
      "pixels": 2,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 2
      }
    },
    "garden-oude-nonnen-boomgaard": {
      "class": "gardenGrass",
      "pixels": 3,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 3
      }
    },
    "garden-oude-nonnen": {
      "class": "gardenGrass",
      "pixels": 26,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 26
      }
    },
    "garden-handboogdoelen": {
      "class": "gardenGrass",
      "pixels": 70,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 70
      }
    },
    "garden-voetboogdoelen": {
      "class": "gardenGrass",
      "pixels": 14,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 14
      }
    },
    "garden-nieuwe-kerk": {
      "class": "gardenGrass",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      }
    },
    "garden-raamsteeg-1": {
      "class": "gardenGrass",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      }
    },
    "garden-raamsteeg-2": {
      "class": "gardenGrass",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      }
    },
    "garden-raamsteeg-3": {
      "class": "gardenGrass",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      }
    },
    "garden-raamsteeg-4": {
      "class": "gardenGrass",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      }
    },
    "meadow": {
      "class": "polderFields",
      "pixels": 123,
      "votes": {
        "nearFields": 9,
        "polderFields": 39,
        "gardenGrass": 75
      },
      "borrowedFrom": "polder-4-3-3"
    },
    "northShore": {
      "class": "nearFields",
      "pixels": 0,
      "votes": {
        "nearFields": 0,
        "polderFields": 0,
        "gardenGrass": 0
      },
      "borrowedFrom": "polder-3-4-4"
    }
  }
}
